import { BaseModel } from "../../../service/models/base";
import { PartyModel } from "../../accounts/models/party_model";
import { AttachmentModel } from "../../prev_purchase_order/model/purchase_order_model";
import { ItemModelV2 } from "./item_model";
import { Project } from "./project_model";
import { UniqueProductModel } from "./stock_transfer_model";
import { WarehouseModel } from "./warehouse_model";

export const NPDStatus = {
  final_review_pending: "Final Review Pending",
  submitted: "Submitted",
};

export const NPDType = {
  internal: "Internal",
  external: "External",
};

export const NPDInwardStatus = {
  incomplete: "Incomplete",
  completed: "Inward Completed",
};

export interface BOMItemModel extends BaseModel {
  item: ItemModelV2;
  qty: number;
  warehouse: WarehouseModel;
}

export interface InwardItemModel extends BaseModel {
  item: ItemModelV2;
  warehouse: WarehouseModel;
  uniqueIds?: UniqueProductModel[];
}

export const defaultInwardItem: InwardItemModel = {
  item: {} as ItemModelV2,
  warehouse: {} as WarehouseModel,
};
export const bomItemDefaultValue: BOMItemModel = {
  item: {} as ItemModelV2,
  qty: 0,
  warehouse: {} as WarehouseModel,
};
export interface NPDModel extends BaseModel {
  project: Project;
  product: ItemModelV2;
  status: string;
  inward_status: string;
  bom_items: BOMItemModel[];
  returned_items?: BOMItemModel[];
  inward_items?: InwardItemModel[];
  type: string;
  party: PartyModel;
  qty: number;
  attachments: AttachmentModel[];
}

export const defaultNPD: NPDModel = {
  project: {} as Project,
  product: {} as ItemModelV2,
  status: NPDStatus.final_review_pending,
  type: "",
  qty: 0,
  inward_status: "",
  attachments: [],
  bom_items: [],
  party: {} as PartyModel,
};
